import { Component, OnInit } 					                  from '@angular/core';
import { Router, ActivatedRoute }                                 from '@angular/router';
import { first }                                                  from 'rxjs/operators';
import { NgxSpinnerService }                                      from 'ngx-spinner';

import { AlertService, LunchpageService }                         from '../_services';
import { Globals  }                                               from '../_helpers';
import config                                                     from '../../config';

@Component({
  selector: 'assessor-start-test',
  templateUrl: './launch-page.component.html',
})

export class LaunchpageComponent implements OnInit{

	userData = {};
	settings = {};
	instructions = [];
	loading = false;
	isCalled = true;
	returnUrl : string;
    isAllowViva = false;
    isAllowPsycho = false;
    isTheory = false;
    isTheory3 = false;
    isTheory4 = false;
    geoIPData = {};
    geoIP = '';
    city = '';
    region = '';
    postal = '';
    loc = '';
    countryip = ''; 
    videostream = 0; 
    feedsetting = {};   
	

	constructor(
        private route: ActivatedRoute,
        private router: Router,
        private lunchpageService: LunchpageService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService
    ) {}

    ngOnInit() {

        var step = this.route.snapshot.paramMap.get("step");
        if(step != this.globals.complSteps['test-start'])
            //this.router.navigateByUrl('/login');

        if(this.globals.isPracticalOver)
            this.router.navigateByUrl('/login'); 
        
        // if(sessionStorage.getItem("pkshn_exam_time") != undefined || sessionStorage.getItem("pkshn_exam_time") != null)
        // {
        //     var remainTime = sessionStorage.getItem("pkshn_exam_time");
        //     var times = remainTime.split(":");
        //     if(parseInt(times[0]) <= 0)
        //     {
        //         this.router.navigateByUrl('/login');
        //     }    
        // }

        this.userData = JSON.parse(localStorage.getItem('currentUser'));
        this.settings = JSON.parse(sessionStorage.pkshn_exam_set);
        // console.log('examstatus '+this.userData['examstatus']);
        // console.log('viva_assessor '+this.settings['viva_assessor']);
        // console.log('module '+this.settings['module']);
        // console.log('viva_first '+this.settings['viva_first']);
        // console.log('viva_assessor '+this.settings['viva_assessor']);
        
        if(this.userData['examstatus'] === undefined)
        {
            this.spinner.show();
            window.location.reload();
            return;
        }
        if(this.settings['entered_psyc'] == 1)
        {
            this.isAllowPsycho = true;
            this.isTheory = false;
            this.isAllowViva = false;
            this.isTheory4 = false;
        }
        else if(this.settings['entered_theory3'] == 1)
        {
            this.isAllowPsycho = false;
            this.isTheory = false;
            this.isAllowViva = false;
            this.isTheory3 = true;
            this.isTheory4 = false;
        }  
        else if(this.settings['entered_theory4'] == 1)
        {
            this.isAllowPsycho = false;
            this.isTheory = false;
            this.isAllowViva = false;
            this.isTheory3 = false;
            this.isTheory4 = true;
        }          
        else{
            if(this.userData['examstatus'] == 0 && this.settings['viva_assessor'] == 0 && (this.settings['module'] >= 2 ) && this.settings['viva_first'] == 1)
            {
                this.isAllowViva = true;
                this.isTheory = false;
            }
            if(this.userData['examstatus'] == 0 && (this.settings['module'] >= 2 ) && this.settings['viva_first'] == 0)
            {
                this.isAllowViva = false;
                this.isTheory = true;
            }
            if(this.userData['examstatus'] == 1 && (this.settings['module'] >= 2 ) && this.settings['viva_first'] == 0)
            {
                this.isAllowViva = true;
                this.isTheory = false;
            }        
            if(this.userData['examstatus'] == 2 && this.settings['viva_assessor'] == 0 && (this.settings['module'] >= 2 ) && this.settings['viva_first'] == 1)
            {
                this.isAllowViva = false;
                this.isTheory = true;
            }
            if(this.userData['examstatus'] == 2 && this.settings['viva_assessor'] == 1 && (this.settings['module'] >= 2 ) && this.settings['viva_first'] == 1)
            {
                this.isAllowViva = false;
                this.isTheory = true;
            }            
            if(this.userData['examstatus'] == 0 && this.settings['module'] == 1)
            {
                this.isAllowViva = false;
                this.isTheory = true;
            }             
        }        
              
    	/* Get Instructions of exam according to type */
    	if(this.isCalled){
    		this.isCalled = false;
    		this.getInstruction();
    	}
 
        // get return url from route parameters or default to '/'
        this.returnUrl = '/';
        // console.log('isAllowViva '+this.isAllowViva);
        // console.log('isTheory '+this.isTheory);
    }

inspdf;
insvideo;
    private getInstruction(){
        this.spinner.show();
        this.lunchpageService.getInstructions(this.globals.root_url, this.userData['usercode'], this.userData['id'], this.settings['exam_id'], this.settings['video'], this.settings['theory2_login'], this.settings['entered_psyc'], this.settings['entered_theory3'], this.settings['entered_theory4'])
        .pipe(first())
        .subscribe(
            data => {
                if(data.code == 1000){
                    this.inspdf = data.pdf_url; 
                    this.insvideo = data.video_link;                     
                    if(data.feed.session != '')
                    {
                         /* set opentalk sessionid and token */
                        //config.SESSION_ID = data.feed.session;
                        //config.TOKEN = data.feed.token; 
                        this.videostream = 1;  
                        let feedsetting = {'sessid':data.feed.session, 'toid':data.feed.token};
                        sessionStorage.setItem('pkshn_feedsetting',JSON.stringify(feedsetting));                   
                    }
                    else
                    {
                        this.videostream = 0;
                    }
                   
                	let inst = (data.instruction).split('\n');
                	for (var i = 0; i < inst.length; ++i) {
                		let html = inst[i];
                        if(html != '')
                		  this.instructions[i] = {index:i+1, text:html};
                	}
                    this.spinner.hide();

                    /* set student geo location */
                    //this.setGeoLocation();
                }
                else if(data.status == 1001){
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                }
                else{
                    this.spinner.hide();
                }
            },
            error => {
                this.spinner.hide();
            }
        );
    }

/*    public setGeoLocation(){
        this.geoIPData = JSON.parse(localStorage.getItem('geoIPStu'));
        var geoipresponse = this.geoIPData;
        if(geoipresponse != undefined)
        {
            this.geoIP = geoipresponse['ip'];
            this.city = geoipresponse['city'];
            this.region = geoipresponse['region'];
            this.postal = geoipresponse['postal'];
            this.loc = geoipresponse['loc'];
            this.countryip = geoipresponse['country'];
        }            
        this.lunchpageService.geoLocation(this.globals.root_url,this.userData['id'], this.settings['exam_id'], 'web', this.geoIP, this.city, this.region, this.postal, this.loc, this.countryip)
        .pipe(first())
        .subscribe(
            data => {
                if(data.code == 1000){
                    // save in hidden.
                }
                else{
                    //error display
                }
            },
            error => {
                this.alertService.error(error);
            }
        );
    }*/


    public theoryPaper(videosetting){
        if(videosetting == 1)
        {
            var parms = this.globals.getRandUrl('theory-test');
            this.router.navigateByUrl('/theory-test/'+parms);
            //window.open("localhost:4200/theory-test")
        }
        else
        {
            var parms = this.globals.getRandUrl('theory-test-nols');
            this.router.navigateByUrl('/theory-test-nols/'+parms);
            //window.open("localhost:4200/theory-test-nols")
        }
    }
    public theoryPaper3(videosetting){
        if(videosetting == 1)
        {
            var parms = this.globals.getRandUrl('theory-test3');
            this.router.navigateByUrl('/theory-test3/'+parms);
            //window.open("localhost:4200/theory-test")
        }
        else
        {
            var parms = this.globals.getRandUrl('theory-test3-nols');
            this.router.navigateByUrl('/theory-test3-nols/'+parms);
            //window.open("localhost:4200/theory-test-nols")
        }
    }
    public theoryPaper4(videosetting){
        if(videosetting == 1)
        {
            var parms = this.globals.getRandUrl('theory-test3');
            this.router.navigateByUrl('/theory-test3/'+parms);
            //window.open("localhost:4200/theory-test")
        }
        else
        {
            var parms = this.globals.getRandUrl('theory-test3-nols');
            this.router.navigateByUrl('/theory-test3-nols/'+parms);
            //window.open("localhost:4200/theory-test-nols")
        }
    }    
    public vivaPaper(){
         var parms = this.globals.getRandUrl('viva-test');
        this.router.navigateByUrl('/viva-test/'+parms);
    } 
    public psychoPaper(videosetting){
        if(videosetting == 0)
        {
            var parms = this.globals.getRandUrl('psycho-test');
            this.router.navigateByUrl('/psychometric/'+parms);
            //window.open("localhost:4200/theory-test")
        }
        else
        {
            var parms = this.globals.getRandUrl('psycho-test-wls');
            this.router.navigateByUrl('/psychometric-wls/'+parms);
            //window.open("localhost:4200/theory-test-nols")
        }
    }    
}
